import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import Input from '../../components/input/input';
import ScrollArea from '../../components/scroll-area/scroll-area';
import Validation from '../../components/validation/validation';

class ScopesFormPage extends React.PureComponent {
    state = {
        name: this.props.model ? this.props.model.scopeName : ''
    };

    setValue = prop => value => {
        this.setState({
            [prop]: value
        });
    };

    render() {
        const scopeId = this.props.model ? this.props.model.scopeId : null;
        return (
            <div className="sten-content sten-schemes-form-page">
                <div className="sten-content__header flex-row">
                    <div className="flex-shrink">
                        <a rel="prev" className="btn-link icon" href="/scopes" title="Back to Scopes list">
                            <span className="icon icon-arrow-left" />
                        </a>
                    </div>
                    <div className="flex-grow">
                        <h1 className="sten-content__title text-uppercase">
                            {scopeId ? `Edit ${this.props.model.scopeName}` : 'Create New Scope' }
                        </h1>
                    </div>
                </div>
                <ScrollArea className="sten-content__body">
                    <Validation.Form
                        method="post"
                        name={scopeId ? 'Edit' : 'Create'}
                    >
                        <div className="sten-content__section">
                            <div className="row">
                                <div className="col-md-6 col-xs-24">
                                    <label className="label">Scope Name</label>
                                    <Validation.Wrapper validations={{ required: true, minLength: 2, maxLength: 50 }}>
                                        <Input
                                            name="ScopeName"
                                            type="text"
                                            value={this.state.name}
                                            onChange={this.setValue('name')}
                                            placeholder="Enter Scope Name"
                                        />
                                    </Validation.Wrapper>
                                </div>
                            </div>
                        </div>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-md-3 col-xs-12">
                                    <a href="/scopes" className="btn btn--secondary col-24">Cancel</a>
                                </div>
                                <div className="col-md-3 col-xs-12">
                                    <Validation.Button className="btn btn--primary col-24">
                                        {scopeId ? 'Save Changes' : 'Create New Scope' }
                                    </Validation.Button>
                                </div>
                            </div>
                        </section>
                        {scopeId && <input type="hidden" name="ScopeId" value={scopeId} />}
                        <input type="hidden" name="__RequestVerificationToken" value={this.props.token} />
                    </Validation.Form>
                </ScrollArea>
            </div>
        );
    }
}

ScopesFormPage.defaultProps = {
    model: null
};

ScopesFormPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any)
};

export default ScopesFormPage;
